import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import colors from '@bit/atd.web.colors'
import Icons, { PropsType as IconProps } from '@bit/atd.web.icons'
import parse from 'html-react-parser'
import dompurify from 'dompurify'
import TextLink from '@bit/atd.web.text-link'

const useStyles = makeStyles({
  textHighlighted: {
    '& em': {
      fontWeight: 600,
      color: colors.ctaPrimary,
      background: 'transparent',
    },
  },
  integratedTitle: {
    color: colors.ctaSecondaryDarker,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '18px',
  },
  integratedDescription: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.textActive,
    marginTop: '11px',
    marginBottom: 0,
  },
  integratedDetails: {
    marginTop: '11px',
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      color: colors.ctaSecondaryDarker,
      width: '16px',
      height: '16px',
    },
    '& > span': {
      fontWeight: 500,
      fontSize: '11px',
      lineHeight: '16px',
      color: colors.ctaSecondaryDarker,
      textTransform: 'uppercase',
      marginLeft: '9px',
      '& b': {
        marginRight: '5px',
      },
    },
  },
})

type PropTypes = {
  title: string
  url: string
  description: string
  categoryIcon: string
  categoryText: string
  createdInfo: string
}

const IntegratedRow = (props: PropTypes): ReactElement => {
  const {
    title,
    description,
    categoryIcon,
    categoryText,
    createdInfo,
    url,
  } = props
  const classes = useStyles()
  return (
    <div>
      <TextLink className={classes.integratedTitle} href={url}>
        {parse(
          dompurify.sanitize(
            `<span class="${classes.textHighlighted}">${title}</span>`,
          ),
        )}
      </TextLink>
      {description && (
        <p className={classes.integratedDescription}>
          {parse(
            dompurify.sanitize(
              `<span class="${classes.textHighlighted}">${description}</span>`,
            ),
          )}
        </p>
      )}
      <div className={classes.integratedDetails}>
        <Icons
          size={14}
          glyph={categoryIcon as IconProps['glyph']}
          color={colors.gray200}
        />
        <>
          <span>{categoryText}</span> <span> {createdInfo}</span>
        </>
      </div>
    </div>
  )
}

export default IntegratedRow
